import { Component } from 'react';
import './styles/search_index_form.scss';

import requestModel from '../../entities/requestModel';

/**
 * компоненты формы
 */

import DepartCity from './components/DepartCity';
import DestinationCountry from './components/DestinationCountry';
import Dates from './components/Dates';
import Nights from './components/Nights';
import Peoples from './components/Peoples';
import Stars from './components/Stars';
import Meals from './components/Meals';
import Hotels from './components/Hotels';
import Price from './components/Price';
import Regions from './components/Regions';
import Services from './components/Services';
import SearchTourButton from './components/SearchTourButton';
import GeoProgressBar from '../../shared/components/GeoProgressBar';
import CartBar from './views/CartBar';
import LinksBar from './views/LinksBar';
import prepareGetParamsToRedirect from './utils/prepareGetParamsToRedirect';

import cabinetAPI from '../api/cabinetAPI';

import DEPART_CITY_DIC from './constants/DepartCity';
import COUNTRY_DIC from './constants/DestinationCountry';
import {
  REQUEST_FIELD_LIST,
  REQUEST_FIELD_TO_URL_MAP,
} from './constants/RequestFieldList';
import { SEARCH_TOUR_INDEX_TITLE } from './constants/';
import { COUNTRY_RANK_DIC } from '../../shared/config';
import geograftourAPI from '../api/geograftourAPI';

class SearchIndexForm extends Component {
  constructor(props) {
    super(props);
    this.setDepart = this.setDepart.bind(this);
    this.setCountry = this.setCountry.bind(this);
    this.setMeal = this.setMeal.bind(this);
    this.setRegions = this.setRegions.bind(this);
    this.setSubRegions = this.setSubRegions.bind(this);
    this.setServices = this.setServices.bind(this);
    this.setActypes = this.setActypes.bind(this);
    this.setHotels = this.setHotels.bind(this);
    this.resetHotels = this.resetHotels.bind(this);
    this.setStars = this.setStars.bind(this);
    this.setRating = this.setRating.bind(this);
    this.setRaces = this.setRaces.bind(this);
    this.setDates = this.setDates.bind(this);
    this.setNights = this.setNights.bind(this);
    this.setPrice = this.setPrice.bind(this);
    this.setPeoples = this.setPeoples.bind(this);
    this.setRecomendHotels = this.setRecomendHotels.bind(this);
    this.setHotelsIdWithReviews = this.setHotelsIdWithReviews.bind(this);
    this.handleHasReviews = this.handleHasReviews.bind(this);
    this.handleRecomend = this.handleRecomend.bind(this);
    this.getQueryParams = this.getQueryParams.bind(this);
    this.goToSearchPage = this.goToSearchPage.bind(this);
    this.setHotelsIdWithReviews = this.setHotelsIdWithReviews.bind(this);

    this.state = {
      request: requestModel,
      is_mobile: false,
      recomend_hotels: [],
      cart: {
        user: null,
        likes: 0,
        seen: 0,
        cart: 0,
      },
      hasReviews: false,
    };
    if (props.DEPART_DATA) {
      this.state.request.departure = this.props.DEPART_DATA.id;
      if (props.DEPART_DATA.country_id == 78) {
        this.state.request.currency = 3;
      }
    }
  }

  handleRecomend(recomendList) {
    this.setState({ recomend_hotels: recomendList });
  }

  handleHasReviews(hasReviews) {
    this.setState({ hasReviews });
  }

  setDepart(value) {
    console.log(
      'установить город по умолчанию',
      value,
      this.state.request.departure,
      DEPART_CITY_DIC[value].country_id
    );
    let currency = 0;
    if (DEPART_CITY_DIC[value].country_id == 78) {
      currency = 3;
    }
    this.setState(
      {
        request: {
          ...this.state.request,
          departure: value,
          currency: currency,
        },
      },
      () => console.log('вылет', this.state.request.departure)
    );
  }

  setMeal(value) {
    this.setState({
      request: {
        ...this.state.request,
        meal: value,
      },
    });
  }

  setCountry(value) {
    this.setState({
      request: {
        ...this.state.request,
        country: value,
        regions: [],
        subregions: [],
        hotels: [],
      },
    });
  }

  setRegions(value) {
    this.setState({
      request: {
        ...this.state.request,
        regions: value,
      },
    });
  }

  setSubRegions(value) {
    this.setState({
      request: {
        ...this.state.request,
        subregions: value,
      },
    });
  }

  setServices(value) {
    this.setState({
      request: {
        ...this.state.request,
        services: value,
      },
    });
  }

  setActypes(value) {
    this.setState({
      request: {
        ...this.state.request,
        actypes: value,
      },
    });
  }

  setRating(value) {
    this.setState({
      request: {
        ...this.state.request,
        rating: value,
      },
    });
  }

  setStars(value) {
    this.setState({
      request: {
        ...this.state.request,
        stars: value,
      },
    });
  }

  setRaces(value) {
    this.setState({
      request: {
        ...this.state.request,
        hideregular: value,
      },
    });
  }

  setHotels(value) {
    this.setState({
      request: {
        ...this.state.request,
        hotels: value,
      },
    });
  }

  resetHotels() {
    this.setState((prevState) => ({
      request: {
        ...prevState.request,
        hotels: [],
      },
    }));
  }

  setPrice({ priceto, pricefrom, currency }) {
    this.setState({
      request: {
        ...this.state.request,
        priceto: priceto,
        pricefrom: pricefrom,
        currency: currency,
      },
    });
  }
  setDates(dates) {
    this.setState({
      request: {
        ...this.state.request,
        dateto: dates.dateto,
        datefrom: dates.datefrom,
      },
    });
  }

  setNights(from, to) {
    this.setState({
      request: {
        ...this.state.request,
        nightsfrom: from,
        nightsto: to,
      },
    });
  }

  setPeoples(params) {
    this.setState({
      request: {
        ...this.state.request,
        adults: params.adults,
        child: params.kids,
        ages: params.ages,
      },
    });
  }

  setRecomendHotels(recomend) {
    this.setState({
      request: {
        ...this.state.request,
        recomend,
      },
    });
  }

  setReviewedHotels(hasReviews) {
    this.setState({
      request: {
        ...this.state.request,
        hasReviews,
      },
    });
  }

  getQueryParams() {
    const { request } = this.state;

    const filteredObj = REQUEST_FIELD_LIST.reduce((acc, field) => {
      if (request.hasOwnProperty(field)) {
        if (typeof REQUEST_FIELD_TO_URL_MAP[field] !== 'undefined') {
          acc[REQUEST_FIELD_TO_URL_MAP[field]] = request[field];
        } else {
          acc[field] = request[field];
        }
      }
      return acc;
    }, {});

    filteredObj.starsbetter = 1;
    filteredObj.mealbetter = 0;

    const queryParams = prepareGetParamsToRedirect(filteredObj);

    return [
      'tours',
      COUNTRY_DIC[request.country].url,
      DEPART_CITY_DIC[request.departure].url,
      `${queryParams}`,
    ].join('/');
  }

  goToSearchPage() {
    const params = this.getQueryParams();
    this.setState(
      {
        in_progress: true,
      },
      () => {
        // alert(params);
        setTimeout(() => (window.location.href = params), 1000);
        console.log(params);
      }
    );
  }

  setCart(cart) {
    this.setState({
      cart: cart,
    });
  }

  async getCart() {
    const cart = await cabinetAPI.getCart();
    this.setCart(cart);
  }

  setHotelsIdWithReviews() {
    geograftourAPI
      .getHotelsWithReviews(this.state.request.country)
      .then((res) => {
        const hotelsIdWithReviews = res.map((hotel) =>
          hotel.tourvisor_id.toString()
        );
        this.setState({
          hotelsIdWithReviews,
          hotelsInfoWithReviews: res,
        });
      });
  }

  componentDidMount() {
    localStorage.removeItem('officeId');
    const isMobile = () =>
      /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile()) {
      this.setState({
        is_mobile: isMobile(),
      });
    }
    const handleResize = () => {
      if (isMobile()) {
        this.setState({
          is_mobile: isMobile(),
        });
      }
    };
    if (this.props.DEPART_DATA) {
      this.setDepart(this.props.DEPART_DATA.id);
    }

    this.getCart();

    window.addEventListener('resize', handleResize);
    this.setDates({
      datefrom: this.state.request.datefrom,
      dateto: this.state.request.dateto,
    });
  }
  render() {
    const {
      departure,
      country,
      datefrom,
      dateto,
      nightsfrom,
      nightsto,
      stars,
      adults,
      child,
      meal,
      hotels,
      pricefrom,
      priceto,
      currency,
      regions,
      subregions,
      services,
      rating,
      hideregular,
      recomend,
      actypes,
    } = this.state.request;
    const { is_mobile, hotelsIdWithReviews, hasReviews } = this.state;
    console.log('render search tour form', departure);

    const CountrySorted = Object.values(COUNTRY_DIC)
      .map(function (item) {
        return {
          id: item.id,
          value: item.id,
          label: item.name,
          name: item.name,
          code: item.code,
          url: item.url,
          rank: item.rank,
          sort: item.rank.toString() + '_' + item.name,
          category: COUNTRY_RANK_DIC[item.rank],
        };
      })
      .sort(function (a, b) {
        if (a.sort < b.sort) return -1;
        if (a.sort > b.sort) return 1;
        return 0;
      });

    return (
      <>
        <h2 className="search__title">{SEARCH_TOUR_INDEX_TITLE}</h2>
        {!is_mobile ? (
          <div className="search-tour-form search-tour-form__index-new container">
            <LinksBar />
            <CartBar cart={this.state.cart} />
            <div className="flex-wrapper">
              <DepartCity
                value={departure}
                onChoose={this.setDepart}
                dictionary={DEPART_CITY_DIC}
              />
              <DestinationCountry
                value={country}
                onChoose={this.setCountry}
                items={CountrySorted}
                dictionary={COUNTRY_DIC}
              />
              <Dates
                datefrom={datefrom}
                dateto={dateto}
                departure={this.state.request.departure}
                country={country}
                currency={currency}
                onChoose={this.setDates}
                hideregular={hideregular}
                onChangeRegular={this.setRaces}
                is_mobile={is_mobile}
              />
              <Nights
                value={[nightsfrom, nightsto]}
                onChoose={this.setNights}
              />
              <Peoples
                adults={adults}
                kids={child}
                onChoose={this.setPeoples}
              />
              <Stars value={stars} onChoose={this.setStars} />
              <Meals value={meal} onChoose={this.setMeal} />
              <Hotels
                isOpen={false}
                value={hotels}
                country={country}
                stars={stars}
                regions={regions}
                recomend={recomend}
                onRecomend={this.handleRecomend}
                rating={rating}
                onChoose={this.setHotels}
                onReset={this.resetHotels}
                onSetRating={this.setRating}
                onSetRecommend={this.setRecomendHotels}
                hasReviews={hasReviews}
                onSetWithReviews={this.handleHasReviews}
                hotelsIdWithReviews={hotelsIdWithReviews}
                setHotelsIdWithReviews={this.setHotelsIdWithReviews}
              />
              <Price
                pricefrom={pricefrom}
                priceto={priceto}
                currency={currency}
                onChoose={this.setPrice}
              />
              <div className="search-widget clickable">
                <SearchTourButton onSearch={this.goToSearchPage} />
              </div>
            </div>
          </div>
        ) : (
          <div className="search-tour-form search-tour-form__index-new search-tour-form__index-new--mobile container">
            <LinksBar />
            <CartBar cart={this.state.cart} />
            <div className="flex-wrapper">
              <DepartCity
                value={departure}
                onChoose={this.setDepart}
                dictionary={DEPART_CITY_DIC}
              />
              <DestinationCountry
                value={country}
                depart={departure}
                currency={currency}
                onChoose={this.setCountry}
                items={CountrySorted}
                dictionary={COUNTRY_DIC}
              />
            </div>
            <div className="flex-wrapper">
              <Dates
                datefrom={this.state.request.datefrom}
                dateto={this.state.request.dateto}
                departure={this.state.request.departure}
                country={country}
                currency={currency}
                onChoose={this.setDates}
                hideregular={hideregular}
                onChangeRegular={this.setRaces}
                is_mobile={is_mobile}
              />
              <Nights
                value={[nightsfrom, nightsto]}
                onChoose={this.setNights}
              />
            </div>
            <div className="flex-wrapper">
              <Peoples
                adults={adults}
                kids={child}
                onChoose={this.setPeoples}
              />
              <Regions
                isOpen={false}
                value={regions}
                subvalue={subregions}
                onSubChoose={this.setSubRegions}
                country={country}
                onChoose={this.setRegions}
              />
            </div>
            <div className="flex-wrapper">
              <Stars value={stars} onChoose={this.setStars} />
              <Meals value={meal} onChoose={this.setMeal} />
            </div>
            <div className="flex-wrapper hotel">
              <Hotels
                isOpen={false}
                value={hotels}
                country={country}
                stars={stars}
                regions={regions}
                recomend={recomend}
                onRecomend={this.handleRecomend}
                rating={rating}
                onChoose={this.setHotels}
                onReset={this.resetHotels}
                onSetRating={this.setRating}
                onSetRecommend={this.setRecomendHotels}
                hasReviews={hasReviews}
                onSetWithReviews={this.handleHasReviews}
                hotelsIdWithReviews={hotelsIdWithReviews}
                setHotelsIdWithReviews={this.setHotelsIdWithReviews}
              />
            </div>
            <div className="flex-wrapper">
              <Price
                pricefrom={pricefrom}
                priceto={priceto}
                currency={currency}
                onChoose={this.setPrice}
              />
              <Services
                valueServices={services}
                valueActypes={actypes}
                onChooseServices={this.setServices}
                onChooseActypes={this.setActypes}
              />
            </div>
            <div className="flex-wrapper">
              <SearchTourButton onSearch={this.goToSearchPage} />
            </div>
          </div>
        )}
        <GeoProgressBar in_progress={this.state.in_progress} />
      </>
    );
  }
}

export default SearchIndexForm;
